import * as React from 'react';

import { Title } from 'common/components';
import { useCreationDefaults } from 'common/hooks';
import { Section } from 'templates/core';
import MeditationCore from '../components/MeditationCore';

const MeditationsCreate = () => {
  const defaultValues = useCreationDefaults();

  return (
    <>
      <Section>
        <Title size="big">Create Meditation</Title>
      </Section>
      <MeditationCore defaultValues={defaultValues} layout="creation" />
    </>
  );
};

export default MeditationsCreate;
